import { useMemo } from 'react';
import {
    getSelectedYearMonths,
    monthsIndexes
} from '../../../../Common/Util/getMonthsByYear';
import { useServicesChartsDataContext } from './useServicesChartsDataContext';

const useServicesPerMonthPerYearTotalChart = () => {
    const { subtitles, chartData, filters } = useServicesChartsDataContext();

    const months = getSelectedYearMonths(filters);

    const series = useMemo(
        () =>
            subtitles.map((item) => {
                const data = months.map((month) => {
                    const found = chartData.selectedYear.find(
                        (counter) =>
                            parseInt(counter.mes_competencia, 10) ===
                            monthsIndexes[month]
                    );

                    return found
                        ? Number(found.average_permanences).toFixed(0)
                        : 0;
                });

                return {
                    name: item,
                    data
                };
            }),
        [chartData, subtitles, months]
    );

    return {
        series,
        subtitles: months
    };
};

export default useServicesPerMonthPerYearTotalChart;
